import React from "react";
import MyInvoiceTable from "./components/MyInvoiceTable";

const MyInvoices = () => {

	return (
		<div>
			<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<MyInvoiceTable />
			</div>
		</div>
	);
};

export default MyInvoices;